/**
    * Tipo de pago de una EntregaDomicilioRealizada. Note que el tipo de pago se especifica por entrega domicilio y no por guia o por desglose de pagos.
    * Esto implica que si el destino quiere pagar una parte con un tipo y otra parte con otro tipo se deben de realizar varias entregas al mismo destinio
    */
export enum TipoPagoEntregaDomicilio {
    Efectivo,
    Cheque,
    Credito
}



// WEBPACK FOOTER //
// ./app/models/entregadomiciliorealizada.ts